import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensDeliverablesList from 'screens/Deliverables/List/ScreensDeliverablesList';
import ScreensDeliverablesForm from 'screens/Deliverables/Form/ScreensDeliverablesForm';

function ScreensDeliverables() {
  return (
    <Routes>
      <Route
        path="/create"
        element={
          <RoutePrivate
            requiredPermission="deliverables.create"
            element={ScreensDeliverablesForm}
            exact
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            requiredPermission="deliverables.update"
            element={ScreensDeliverablesForm}
            exact
          />
        }
      />
      <Route
        path="/list"
        element={
          <RoutePrivate
            requiredPermission="deliverables.list"
            element={ScreensDeliverablesList}
            exact
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/deliverables/list" />} />
    </Routes>
  );
}

export default ScreensDeliverables;
